import { SubscriptionStatus } from '@square/dashboard-protos/models/squareup/sub2/common';
export const CATALOG_NAME = 'square_one_subscription';
export const FEATURE = 'Square Subscriptions';
export const ACTIVITY = 'Subscription Management';
export let SquareOneEvents = /*#__PURE__*/function (SquareOneEvents) {
  SquareOneEvents["LOCATION_CHANGE_WARNING_VIEW"] = "View SquareOne Plan Location Change Warning";
  SquareOneEvents["LOCATION_CHANGE_WARNING_DISMISS"] = "Dismiss SquareOne Plan Location Change Warning";
  SquareOneEvents["LOCATION_CHANGE_MODAL_VIEW"] = "View SquareOne Plan Location Change Modal";
  SquareOneEvents["LOCATION_CHANGE_MODAL_CONFIRM"] = "Click SquareOne Confirm Plan New Location Costs";
  SquareOneEvents["LOCATION_CHANGE_MODAL_EXIT"] = "Click SquareOne Exit Location Change Modal";
  SquareOneEvents["DEVICE_CHANGE_MODAL_VIEW"] = "View SquareOne Device Management Change Modal";
  SquareOneEvents["DEVICE_CHANGE_MODAL_CONFIRM"] = "Click SquareOne Confirm New Device Costs";
  SquareOneEvents["DEVICE_CHANGE_MODAL_EXIT"] = "Click SquareOne Exit Device Change Modal";
  return SquareOneEvents;
}({});
/**
 * Tracks a Square One event
 *
 * @param dataApi - The data API to use for tracking
 * @param eventName - The name of the event to track
 * @param properties - Additional properties to include in the event
 * @param squareOnePricingInfo - Optional Square One pricing info
 */
export function trackSquareOneEvent(dataApi, eventName, properties = {}, squareOnePricingInfo) {
  const eventProperties = {
    catalog_name: CATALOG_NAME,
    feature: FEATURE,
    activity: ACTIVITY,
    ...properties
  };
  if (squareOnePricingInfo) {
    const {
      planToken,
      status
    } = squareOnePricingInfo;
    if (planToken) {
      eventProperties.current_plan_token = planToken;
    }
    if (status) {
      eventProperties.current_subscription_status = typeof status === 'number' ? SubscriptionStatus[status] || String(SubscriptionStatus.INVALID) : status;
    }
  }
  dataApi.track(eventName, eventProperties);
}